import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function ArtifactImage({ jobId, filename, alt, ...props }) {
  const [url, setUrl] = useState("");
  useEffect(() => {
    setUrl("");
    let active = true;
    let objectUrl;
    const controller = new AbortController();
    if (filename) api.get(`/jobs/${jobId}/artifacts/${encodeURIComponent(filename)}`, { responseType: "blob", signal: controller.signal })
      .then(({ data }) => { objectUrl = URL.createObjectURL(data); if (active) setUrl(objectUrl); else URL.revokeObjectURL(objectUrl); })
      .catch(() => {});
    return () => { active = false; controller.abort(); if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [jobId, filename]);
  return url ? <img src={url} alt={alt} {...props} /> : <span className="text-xs text-slate-500">Image unavailable</span>;
}
